// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconImageImageSmall_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 3.925C10 4.46348 9.55229 4.9 9 4.9C8.44771 4.9 8 4.46348 8 3.925C8 3.38652 8.44771 2.95 9 2.95C9.55229 2.95 10 3.38652 10 3.925Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1H0V10.75H12V1ZM10.9999 9.775L11 1.975H1V9.2875L4 4.9L6.39996 8.40994L7.9999 6.84999L10.9999 9.775Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.25 8.09768C11.9403 8.09768 12.5 7.53803 12.5 6.84768C12.5 6.15732 11.9403 5.59768 11.25 5.59768C10.5596 5.59768 9.99997 6.15732 9.99997 6.84768C9.99997 7.53803 10.5596 8.09768 11.25 8.09768Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 14V3H15V14H1ZM2.5 4.5H13.5V12.5L10.5001 9.50056L8.70238 11.298L5.5 7.09766L2.5 11.0326V4.5Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.5 11C18.3284 11 19 10.3284 19 9.5C19 8.67157 18.3284 8 17.5 8C16.6716 8 16 8.67157 16 9.5C16 10.3284 16.6716 11 17.5 11Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 19.9994H2V4H22V19.9994ZM4 6H20V17.9993L15.5 13.501L12.6184 16.2411L8.5 10.9995L4 16.7268V6Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22 14C23.1046 14 24 13.1046 24 12C24 10.8954 23.1046 10 22 10C20.8954 10 20 10.8954 20 12C20 13.1046 20.8954 14 22 14Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6H28V26H4V6ZM6 8H26V23.8571L20 17L16.0526 20.9474L11 14L6 21.0833V8Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M62 58H2V8H62V58ZM6 12H58V51L45 35L35.9815 45.9292L21 27.5L6 45.6562V12ZM48 28C51.3137 28 54 25.3137 54 22C54 18.6863 51.3137 16 48 16C44.6863 16 42 18.6863 42 22C42 25.3137 44.6863 28 48 28Z" class="svg-bg"/>
</svg>
`;
/**
 * IconImageImageSmall is a generated icon component.
 */
let IconImageImageSmall = IconImageImageSmall_1 = class IconImageImageSmall extends IconBaseElement {
    render() {
        return html `${IconImageImageSmall_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconImageImageSmall.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s64IconSvg],
    ['s48', _s64IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconImageImageSmall = IconImageImageSmall_1 = __decorate([
    customElement('zui-icon-image-image-small')
], IconImageImageSmall);
export { IconImageImageSmall };
